<template>
  <v-dialog max-width="670" :value="visible" @click:outside="close">
    <v-card class="py-10 px-7">
      <CloseDialogButton :close="close" />
      <span
        class="align-center d-flex flex-column mb-8 Not-Currently-Accepting-Orders"
      >
        Not Currently Accepting Orders
      </span>
      <div class="align-center d-flex flex-column">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="92"
          height="102"
          viewBox="0 0 92 102"
          fill="none"
        >
          <g clip-path="url(#fbdacjwppa)" fill="#E21B23">
            <path
              d="M88.464 83.367H22.086c-.816 0-1.166-1.068-.526-1.559l9.239-7.074h52.797c3.753 0 6.866-3.073 6.94-6.805l.592-30.328c.067-3.458-2.474-6.459-5.912-6.971-1.654-.247-3.203.885-3.45 2.537a3.02 3.02 0 0 0 2.552 3.432.866.866 0 0 1 .741.87l-.592 30.343c-.01.468-.4.882-.87.882H32.18L22.6 27.448l4.863.706a3.039 3.039 0 0 0 3.45-2.549 3.028 3.028 0 0 0-2.553-3.438l-7.283-1.087-2.782-10.777c-.345-1.335-1.555-2.246-2.94-2.246H3.536A3.03 3.03 0 0 0 .5 11.079 3.029 3.029 0 0 0 3.536 14.1H13L26.37 70.45l-8.517 6.535c-5.138 3.943-2.248 12.43 4.234 12.43h7.968c-.352.864-.546 1.963-.546 3.044 0 4.996 4.111 9.046 9.164 9.046 5.052 0 9.164-4.04 9.164-9.038 0-1.082-.194-2.19-.547-3.052h16.578c-.353.864-.547 1.963-.547 3.044 0 4.996 4.112 9.046 9.164 9.046 5.053 0 9.165-4.04 9.165-9.038 0-1.082-.195-2.19-.547-3.052h7.358a3.03 3.03 0 0 0 3.036-3.022 3.029 3.029 0 0 0-3.036-3.022l.004-.004zM38.672 95.44c-1.705 0-3.094-1.355-3.094-3.022 0-1.667 1.389-3.022 3.094-3.022 1.705 0 3.094 1.355 3.094 3.022 0 1.667-1.389 3.022-3.094 3.022zm33.814 0c-1.705 0-3.093-1.355-3.093-3.022 0-1.667 1.388-3.022 3.093-3.022 1.706 0 3.094 1.355 3.094 3.022 0 1.667-1.388 3.022-3.094 3.022z"
            />
            <path
              d="M56.012 44.288c-12.157 0-22.046-9.822-22.046-21.894 0-12.073 9.89-21.895 22.046-21.895 12.155 0 22.046 9.822 22.046 21.895 0 12.072-9.89 21.894-22.046 21.894zm0-37.748c-8.81 0-15.976 7.111-15.976 15.854 0 8.743 7.166 15.854 15.976 15.854s15.975-7.111 15.975-15.854c0-8.743-7.166-15.854-15.975-15.854z"
            />
            <path
              d="M63.693 14.708a2.553 2.553 0 0 0-3.601-.002l-.002.002-4.124 4.095-4.123-4.095a2.552 2.552 0 0 0-3.589.277 2.528 2.528 0 0 0 0 3.298l4.112 4.107-4.112 4.107a2.529 2.529 0 0 0 .17 3.582c.969.878 2.448.88 3.419.006l4.123-4.107 4.124 4.107a2.555 2.555 0 0 0 1.794.736 2.54 2.54 0 0 0 2.547-2.533c0-.67-.265-1.314-.74-1.79l-4.124-4.106 4.124-4.107a2.529 2.529 0 0 0 0-3.575l.002-.002z"
            />
          </g>
          <defs>
            <clipPath id="fbdacjwppa">
              <path
                fill="#fff"
                transform="translate(.5 .5)"
                d="M0 0h91v101H0z"
              />
            </clipPath>
          </defs>
        </svg>
        <div class="font-size-lg mt-8 mb-12 text-center">
          {{ closedForDeliveryMessage }}
        </div>
        <v-btn
          color="primary"
          height="48"
          width="180"
          rounded
          @click.stop="close"
        >
          <div class="font-size-md">ok</div>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";

export default {
  name: "ClosedForDeliveryDialog",
  components: { CloseDialogButton },
  computed: {
    ...mapState({
      closedForDeliveryMessage: (state) =>
        state.cart.closedForDeliveryMessage.substring(
          0,
          state.cart.closedForDeliveryMessage.lastIndexOf("If") > 0
            ? state.cart.closedForDeliveryMessage.lastIndexOf("If")
            : undefined,
        ),
    }),
  },
  props: { visible: Boolean, close: Function },
};
</script>

<style scoped>
.Not-Currently-Accepting-Orders {
  font-family: Roboto;
  font-size: 26px;
  font-weight: bold;
}
</style>
